import { toPlainText } from "@portabletext/react";
import { useMatches } from "react-router";

import SeoHead from "~/components/SeoHead";
import type { RouteLoader, RouteData } from "~/lib/types";

export const useSeo = ({ globalConfig }: RouteData<any>) => {
  const rootData = useMatches().find((match) => match.id !== "root");
  const routeData = (rootData?.data as RouteLoader<any> | null)?.data?.routeData;

  let title = undefined;
  let description = undefined;
  let canonicalURL = undefined;

  if (!routeData.seo) {
    routeData.seo = {};
  }

  if (rootData?.id === "routes/community/$slug" || rootData?.id === "routes/team/$slug") {
    title = routeData?.seo?.title ?? routeData?.title ?? routeData?.name;
    description =
      routeData?.seo?.description ??
      (routeData?.bio ? toPlainText(routeData?.bio as any) : undefined);
  } else if (rootData?.id === "routes/portfolio/spotlights/$slug") {
    title = routeData?.seo?.title ?? routeData?.organization?.name;
    description = routeData?.seo?.description;
  } else if (rootData?.id === "routes/404/index") {
    title = "404";
    description = routeData?.seo?.description;
    canonicalURL = "https://www.heavybit.com";
  } else {
    title = routeData?.seo?.title ?? routeData?.title ?? routeData?.name;
    description = routeData?.seo?.description ?? routeData?.description;
  }

  if (!routeData?.seo?.OGimage) {
    routeData.seo.OGimage = globalConfig.OGimage;
  }

  return (
    <SeoHead
      seo={{
        ...routeData?.seo,
        title,
        description,
        canonicalURL,
      }}
    />
  );
};
